<div class="modal-body shadowSm1 p-0">
    <app-notes-list [title]="title"></app-notes-list>
    <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-primary m-3" (click)="modalRef.hide()">Close</button>
    </div>
</div>